import { render, staticRenderFns } from "./statusDesc.vue?vue&type=template&id=14dee496&scoped=true"
import script from "./statusDesc.vue?vue&type=script&lang=js"
export * from "./statusDesc.vue?vue&type=script&lang=js"
import style0 from "./statusDesc.vue?vue&type=style&index=0&id=14dee496&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14dee496",
  null
  
)

export default component.exports